module.exports = __webpack_public_path__ + "static/media/wahana-logo.db7e39d4.png";